import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import Logo from './Logo.jsx';
import { config } from '../config.js';

const NAV = [
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Para quem', href: '#para-quem' },
  { label: 'Condomínios', href: '#condominios' },
  { label: 'Planos', href: '#planos' },
  { label: 'Dúvidas', href: '#duvidas' },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: 'rgba(26,4,48,0.82)',
        backdropFilter: 'blur(14px)',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ gap: 2, minHeight: 72 }}>
          <Logo />
          <Box sx={{ flexGrow: 1 }} />

          <Stack direction="row" spacing={3} sx={{ display: { xs: 'none', md: 'flex' } }}>
            {NAV.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                color="text.secondary"
                sx={{ fontWeight: 600, '&:hover': { color: 'text.primary' } }}
              >
                {item.label}
              </Link>
            ))}
          </Stack>

          <Button
            href={config.appUrl}
            variant="contained"
            color="secondary"
            sx={{ display: { xs: 'none', sm: 'inline-flex' }, ml: { md: 3 } }}
          >
            Entrar
          </Button>

          <IconButton
            onClick={() => setOpen(true)}
            aria-label="Abrir menu de navegação"
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        slotProps={{
          paper: {
            sx: {
              // Ocupa a tela toda no celular, com fundo solido (sem
              // transparencia) para a leitura ficar nitida.
              width: '100vw',
              maxWidth: '100vw',
              height: '100%',
              backgroundColor: 'background.default',
              backgroundImage: 'none',
              backdropFilter: 'none',
            },
          },
        }}
      >
        <Box
          role="presentation"
          sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <Stack
            direction="row"
            sx={{ alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, minHeight: 72 }}
          >
            <Logo />
            <IconButton
              onClick={() => setOpen(false)}
              aria-label="Fechar menu de navegação"
              sx={{ color: 'text.primary' }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>

          <List sx={{ px: 1, flexGrow: 1 }}>
            {NAV.map((item) => (
              <ListItemButton
                key={item.href}
                component="a"
                href={item.href}
                onClick={() => setOpen(false)}
                sx={{ borderRadius: 2, py: 1.5 }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ variant: 'h6', fontWeight: 600 }}
                />
              </ListItemButton>
            ))}
          </List>

          <Box sx={{ p: 2 }}>
            <Button
              href={config.appUrl}
              variant="contained"
              color="secondary"
              size="large"
              fullWidth
              onClick={() => setOpen(false)}
            >
              Entrar na plataforma
            </Button>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
}
